import { makeStyles } from "@material-ui/core";
import { Colors } from "styles/Colors";

export const CONTROL_HEIGHT = 34;
export const CONTROL_HEIGHT_DESKTOP = 38;
const CAPS_NUDGE = "translateY(0.07em)";

export const useEventControlStyles = makeStyles((theme) => {
	const desktop = theme.breakpoints.up("md");

	return {
		status: {
			display: "inline-flex",
			alignItems: "center",
			gap: 8,
			height: CONTROL_HEIGHT,
			color: Colors.primaryDark,
			cursor: "default",
			fontSize: 11,
			fontWeight: 600,
			letterSpacing: "0.18em",
			textTransform: "uppercase",

			"& svg": {
				width: 15,
				height: 15,
				flex: "0 0 auto",
			},

			[desktop]: {
				height: CONTROL_HEIGHT_DESKTOP,
				fontSize: 12,

				"& svg": {
					width: 16,
					height: 16,
				},
			},
		},
		statusLabel: {
			transform: CAPS_NUDGE,
		},
		submitted: {
			"& svg": {
				color: Colors.pickstopGreen,
			},
		},
		lockedChip: {
			padding: "0 14px",
			borderRadius: 999,
			border: "1px solid rgba(255, 255, 255, 0.16)",
			color: Colors.primaryDarker,
			boxSizing: "border-box",

			"& svg": {
				color: Colors.primaryDarker,
			},

			[desktop]: {
				padding: "0 16px",
			},
		},
		action: {
			height: CONTROL_HEIGHT,
			padding: "0 18px",
			borderRadius: 999,
			backgroundColor: Colors.primary,
			color: Colors.panel,
			fontSize: 11,
			fontWeight: 700,
			letterSpacing: "0.18em",
			transition:
				"background-color 120ms ease, transform 120ms ease, box-shadow 120ms ease",

			"&:hover": {
				backgroundColor: Colors.primaryDark,
				transform: "translateY(-1px)",
			},

			"& .MuiButton-startIcon": {
				marginRight: 8,
				marginLeft: 0,
			},

			"& svg": {
				width: 14,
				height: 14,
			},

			[desktop]: {
				height: CONTROL_HEIGHT_DESKTOP,
				padding: "0 20px",
				fontSize: 12,

				"& svg": {
					width: 15,
					height: 15,
				},
			},
		},
	};
});
